import React from 'react';
import { useEffect } from 'react';

function About() {

    useEffect(() => {
    document.title = "About Zane — Swing & Blues Dance Teacher in Berlin";
    }, []);
    return (
    <div>
    <div className = 'Taffel'>I'm Zane a dance teacher, novice front end developer, and humanist. 
    Originally from the Bay Area of California, I'm now living and thriving in Berlin, Germany.

        </div>
        <div className = 'Taffel'>
            I started dancing swing way back in 2004 when a girl from my class dragged me along. 
            I fell in love with the dance and have been dancing ever since. 
            In 2010 I started organising and teaching with a uni club. 
        </div>
        <div className = 'Taffel'>    
            Since 2017 I've been involved in the Berlin Blues and Swing scenes. 
            I'm currently working for a dance school Maxixe.de, organizing for Lovelite 
            and do some of my own projects including <br/>shag practice 
            group: <a className ='info' href = 'https://t.me/+vipkFaU5ep42MDRi'>telegram</a>
            <br/>and Blues practice group: < a className='info' href = 'https://t.me/+B1gU02udh6oyZWNk'>telegram</a>
        </div>
        <div className = 'Taffel'>    
            I originally designed this website to help me practice Javascript, CSS, React, etc. 
            during the Pandemic. 
            I'm constantly iterating, and implementing new concepts
        </div >
        <div className = 'Taffel'>
            On tech:
            I find the web3 and decentralized tech stack to be super interesting, 
            and I have a particular interest in tokenomics and regenerative finance. 
            I'm interested in how we can create recursive positive externalities to create
             a better more sustainable world, and an economy that works for the people. 
             I spend quite a bit of time thinking about cash-flows as primatives. 
             A couple of projects that I like are KlimaDAO, for carbon removal, 
             Circles for UBI/local currencies.
        </div >

        <div className = 'Taffel'>
            I'm currently working for Coffee Circle a specialty coffee company invested 
            in ecological development in countries of origin. 
            Please reach out if you want to collaborate, or if there is something interesting 
            I should know about. zane.payer@gmail.com
        </div>
    </div>
    )
  }

  export default About